import {
  CreateNextWorkflow,
  DeleteNextWorkflow,
} from "data/libs/nextWorkflows";

export const addNextWorkflow = CreateNextWorkflow;

export const deleteNextWorkflow = DeleteNextWorkflow;

export default addNextWorkflow;
